import WebApi from "@/views/loyalty/shared/modules/web_api"

export class CampaignEndpoint {
    constructor () {
        this.url = `${process.env.VUE_APP_LOYALTY_URL}api/campaign/`
        this.url2 = `${process.env.VUE_APP_LOYALTY_URL}api/campaigns/`
        this.webApi = new WebApi()
    }

    async create_campaign (campaign) {
        const response = await this.webApi.post(`${this.url}`, campaign)
        if (!response.status_code) {
            return response
        } else {
            console.error(`Ошибка с кодом: ${response.status_code}`)
        }
    }

    async delete_campaign (campaignId) {
        const response = await this.webApi.delete(`${this.url}${campaignId}`)
        if (!response.status_code) {
            return response
        } else {
            console.error(`Ошибка с кодом: ${response.status_code}`)
        }
    }

    async read_campaigns (page, limit, filter, search) {
        const campaigns = await this.webApi.post(`${this.url2}all`, {
            page: page,
            limit: limit,
            filter: filter,
            search: search
        })
        if (!campaigns.status_code) {
            return campaigns
        } else {
            console.error(`Ошибка с кодом: ${campaigns.status_code}`)
        }
    }

    async read_campaigns_by_customerId (customerId, page, limit, filter, search) {
        const campaigns = await this.webApi.post(`${this.url2}customer/${customerId}`, {
            page: page,
            limit: limit,
            filter: filter,
            search: search
        })
        if (!campaigns.status_code) {
            return campaigns
        } else {
            console.error(`Ошибка с кодом: ${campaigns.status_code}`)
        }
    }
}
